
import "./CustomInput.scss"

const ReportCustomInput = (props: any) => {

    const { inputType, inputLabel, width, error, onChange, minLength,maxLength,...inputProps } = props;

    const optionElements = () => {
        return inputProps.options?.map((res: any, index: number) => { return <option key={index} value={res.value}> {res.value}</option> })
    }
    return (
        <div className="search-element" style={{ width: width ? width : "225px" }}>
            <p className="input-label"> {inputLabel} {props.required && <span className='redAstric'> * </span>} </p>
            {inputType === "input" && <input className={`search-input`}  {...inputProps} onChange={onChange} autoComplete="off" minLength={minLength} maxLength={maxLength}/>}
            {error && <span className='statusError'> {error} </span>}
        </div>
    )
}
export default ReportCustomInput;
